module.exports = __webpack_public_path__ + "assets/img/27_1241.1b99ce61.jpg";